import React, { useContext, useEffect, useState } from 'react'

import { CSVLink } from 'react-csv'

import { Icon } from '../../components/Icon'
import {
  IncidentsHeadersAdmin,
  // policyHeader,
  policyTableData,
} from '../../data/index'
import Menu from '../../components/UI/UIMenu'
import Modal from '../../components/UI/UIModal'
import UITextArea from '../../components/UI/UITextArea'
import UISubHeaderComponent from '../../components/UI/UISubHeaderComponent'
// import Pagination from '../../components/UI/Pagination'
import '../../App.css'
import UiSelect from '../../components/UI/UISelect'
import UIButton from '../../components/UI/UIButton'
import { incidentData } from '../../utils/types'
import {
  createIncident,
  deleteIncident,
  updateIncident,
} from '../../api/admin/incidents'
import { toast } from 'react-toastify'
import { useQuery } from 'react-query'
// import UIDatePickerv from '../../components/UI/UIDatePickerv'
import Loading from '../../components/UI/Loading'
import {
  // calculatePageCount,
  checkValidation,
  initialData,
  SeverityIcon,
} from './utils'
import { getIncidentData, getIncidentDataById } from './apiCalls'
import {
  capitalizeFirstLetter,
  formatDate,
  statusBgColorWhistleblowing,
} from '../../utils/utils'
import UITextInput from '../../components/UI/UITextInput'
import UIMultiSelect from '../../components/UI/UIMultiSelect'
import {
  exportToExcel,
  handleDownloadHtml,
  handleDownloadTxt,
} from '../policy/utils'
import { UIExportHtmlTable } from '../../components/UI/UIExportHtmlTable'
import { SidebarContext } from '../../context/SidebarContext'
interface incidents {
  Report_No: number
  Status: string
  Severity_Level: string
  Name_of_Candidate: string
  Name_of_Employer: string
  Date_Reported: string
  Updated_At: string
  Created_By: string
  Updated_By: string
}

export interface FormData {
  candidate: string
  employer: string
  severity_level: string
  overview: string
  status: string
  receivedDate?: string
  receivedBy?: string

  supportRequirementRating?: string
  immediateActionTaken?: string
  furtherActionRequired?: string
  monitoringRequired?: string
  conclusionOfOutcome?: string
}

const Incidents = () => {
  const { viewBool, setViewBool } = useContext(SidebarContext)

  const [formData, setFormData] = useState<FormData | incidentData>(initialData)
  const [id, setId] = useState('')
  const [isExportOpen, setIsExportOpen] = useState<boolean>(false)
  const [isConfrim, setIsConfrim] = useState<boolean>(false)
  const [isOpen, setIsOpen] = useState(false)
  const [isOpenDelete, setIsOpenDelete] = useState(false)
  const [showOtherPart, setShowOtherPart] = useState(false)
  const [isView, setIsView] = useState(viewBool)
  const [isEdit, setIsEdit] = useState(false)
  const [fileHeader] = useState([
    { key: 'Report_No', label: 'Report No' },
    { key: 'Status', label: 'Status' },
    { key: 'Severity_Level', label: 'Severity Level' },
    { key: 'Name_of_Candidate', label: 'Incident Concerning' },
    { key: 'Name_of_Employer', label: 'Name of Employer' },
    { key: 'Date_Reported', label: 'Date Reported' },
    { key: 'Updated_At', label: 'Updated At' },
    { key: 'Created_By', label: 'Created By' },
    { key: 'Updated_By', label: 'Updated By' },
  ])

  useEffect(() => {
    setIsView(viewBool)
  }, [viewBool])
  const [fileType, setFileType] = useState<string>('')

  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(policyTableData?.length || 100).fill(false)
  )
  const [sortOrder, setSortOrder] = useState<{
    [key: string]: 'asc' | 'desc'
  }>({})
  const [sortBy, setSortBy] = useState<string>('reportNo')
  const [sortOrderValue, setSortOrderValue] = useState<string>('asc')

  const incidents = useQuery('policy', () =>
    getIncidentData(
      // currentPage,
      sortBy,
      sortOrderValue
    )
  )

  const handleSort = (key: string) => {
    const newSortOrder = { ...sortOrder }
    if (newSortOrder[key] === 'asc' || newSortOrder[key] === undefined) {
      newSortOrder[key] = 'desc'
      setSortBy(key)
      setSortOrderValue('desc')
    } else {
      newSortOrder[key] = 'asc'
      setSortBy(key)
      setSortOrderValue('asc')
    }
    setSortOrder(newSortOrder)
  }

  useEffect(() => {
    incidents.refetch() // Refetch incidents when sortBy or sortOrderValue changes
  }, [sortBy, sortOrderValue])

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const handleOpenModal = () => {
    setIsOpen(true)
    setFormData(initialData)
  }

  const handleCloseModal = () => {
    setIsOpen(false)
    setIsEdit(false)
  }
  const handleCloseDeleteModal = () => {
    setIsOpenDelete(false)
  }
  const handleExportCloseModal = () => {
    setIsExportOpen(false)
  }

  const incidentById = useQuery(
    ['incidentById', id],
    () => getIncidentDataById(id),
    {
      enabled: !!id, // Only fetch data when id is truthy
    }
  )

  const handleChange = (fieldName: string, value: string): void => {
    setFormData((prevState) => ({
      ...prevState,
      [fieldName]: value,
    }))
  }

  const createNewIncident = async (): Promise<void> => {
    try {
      const response = (await createIncident(formData)) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        incidents.refetch()
        handleCloseModal()
        setFormData(initialData)
        toast.success('Incident Created.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const removePolicy = async (): Promise<void> => {
    try {
      const response = (await deleteIncident({ id: id })) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        incidents.refetch()
        setIsEdit(false)
        setIsView(false)
        setIsOpenDelete(!isOpenDelete)
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('An error occurred while deleting partner.', {
        position: 'top-right',
      })
    }
  }
  const editIncident = async (): Promise<void> => {
    try {
      const response = (await updateIncident(formData, id)) as {
        status?: string
        data: incidentData
      }
      if (response?.status == 'successful') {
        incidents.refetch()
        incidentById.refetch()
        // setIsOpen(!isOpen)
        setIsEdit(false)
        setFormData(initialData)
        toast.success('Incident Updated.', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      toast.error('Network Error.', {
        position: 'top-right',
      })
    }
  }

  const columns = [
    {
      title: 'Report No',
      column: 'reportNo',
    },
    {
      title: 'Status',
      column: 'status',
    },
    {
      title: 'Severity Level',
      column: 'severity_level',
    },
    {
      title: 'Report No',
      column: 'reportNo',
    },
    {
      title: 'Candidate',
      column: 'candidate',
    },
    {
      title: 'Employer',
      column: 'employer',
    },
    {
      title: 'Created At',
      column: 'createdAt',
    },
    {
      title: 'Updated At',
      column: 'updatedAt',
    },
    {
      title: 'Created By Name',
      column: 'createdByName',
    },
    {
      title: 'Updated At',
      column: 'updatedAt',
    },
  ]

  return (
    <div
      className={
        'flex flex-col gap-20 w-full bg-white  h-full rounded-3xl p-8  '
      }
    >
      {!isView && (
        <div className="flex flex-col gap-10 custom-scrollbar w-full relative h-full">
          <div className={'flex w-full justify-between items-start '}>
            <div className="flex-col w-[50%] gap-[20px]">
              <p className={'text-[18px] text-text2 font-bold '}>Incidents</p>
            </div>
            <div className={'flex flex-row gap-[15px]'}>
              <div
                onClick={() => {
                  handleOpenModal()
                }}
                className="gap-[10px]  bg-bluishGreen items-center justify-between min-w-[95px] text-white h-12 px-[20px] flex rounded-[72px]   cursor-pointer "
              >
                <p className={'font-medium text-[14px] text-white'}>
                  Create Report
                </p>
                <Icon
                  name={'IconPlus'}
                  strokeWidth={1}
                  stroke={'white'}
                  width={16}
                  height={16}
                />
              </div>
            </div>
          </div>
          {/* content container */}
          <div className="relative h-full overflow-y-auto">
            <div className=" max-h-full h-full overflow-y-auto">
              {incidents.isLoading && (
                <div className="flex-col  w-[100%] p-[10px]">
                  <Loading size="large" />
                </div>
              )}
              {!incidents.isLoading && (
                <table className="min-w-full table-auto divide-y-4 divide-white">
                  <thead className="sticky top-0 z-10 mb-4">
                    <tr className="bg-gray2 rounded-lg h-10 mb-18">
                      {IncidentsHeadersAdmin?.map((item, index: number) => {
                        return (
                          <th
                            key={index}
                            className={`px-4 py-3 text-left ${index === 0 ? 'rounded-l-lg' : ''} ${index === IncidentsHeadersAdmin.length - 1 ? 'border-none' : 'border-r border-white'}`}
                          >
                            <div className="flex items-center">
                              <p className="text-text1 font-semibold text-sm flex-1">
                                {item.replace(/_/g, ' ')}
                              </p>
                              <div
                                onClick={() => {
                                  let sortBy = ''
                                  switch (item as keyof incidents) {
                                    case 'Report_No':
                                      sortBy = 'reportNo'
                                      break
                                    case 'Status':
                                      sortBy = 'status'
                                      break
                                    case 'Severity_Level':
                                      sortBy = 'severity_level'
                                      break
                                    case 'Name_of_Candidate':
                                      sortBy = 'candidate'
                                      break
                                    case 'Name_of_Employer':
                                      sortBy = 'employer'
                                      break
                                    case 'Date_Reported':
                                      sortBy = 'createdAt'
                                      break
                                    case 'Updated_At':
                                      sortBy = 'updatedAt'
                                      break
                                    case 'Created_By':
                                      sortBy = 'createdByName'
                                      break
                                    case 'Updated_By':
                                      sortBy = 'updatedByName'
                                      break
                                    default:
                                      break
                                  }
                                  handleSort(sortBy)
                                }}
                              >
                                <Icon
                                  name={'IconChevronDown'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1}
                                  stroke={'#67A5B9'}
                                />
                              </div>
                            </div>
                          </th>
                        )
                      })}
                      <th className="w-[56px] rounded-r-lg"></th>{' '}
                    </tr>
                  </thead>
                  <tbody>
                    {incidents?.data?.data?.map((item, index) => (
                      <>
                        <tr className="bg-gray1">
                          {/* Example row */}
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {item?.reportNo}
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {
                              <div
                                className={`px-[10px] flex justify-center items-center bg-${statusBgColorWhistleblowing(item?.status)} h-[28px] rounded-[100px]`}
                              >
                                <p className="text-xs font-medium leading-5 text-text1">
                                  {capitalizeFirstLetter(item.status || '')}
                                </p>
                              </div>
                            }
                          </td>
                          <td className="px-4 min-w-[135px] font-medium text-textError text-[12px] h-[48px] py-2 border border-white">
                            <SeverityIcon
                              severity_level={item.severity_level}
                            />
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <p className="text-xs text-text3 font-medium">
                              {item.candidate}
                            </p>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <p className="text-xs text-text3 font-medium">
                              {item.employer}
                            </p>
                          </td>
                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            {formatDate(item?.createdAt || '')}
                          </td>

                          <td className="px-4 text-text1 font-medium text-[12px] h-[48px] py-2 border border-white">
                            <p className="text-xs text-text3 font-medium">
                              {item?.createdByName}
                            </p>
                          </td>
                          <td className="px-4 h-[48px] py-2 border border-white">
                            {item.updatedByName ? (
                              <p className="text-xs text-text1 font-medium">
                                {formatDate(item?.updatedAt || '')}
                              </p>
                            ) : (
                              <p className="text-xs text-text1 font-medium"></p>
                            )}
                          </td>

                          <td className="px-4 h-[48px] py-2 border border-white">
                            <p className="text-xs text-text1 font-medium">
                              {item.updatedByName}
                            </p>
                          </td>
                          <td className="px-4 items-center justify-center flex  relative h-[48px] py-2 border border-white">
                            <Menu
                              isOpen={isOpenMenu[index]}
                              items={[
                                {
                                  label: 'View',
                                  onClick: () => {
                                    handleToggleMenu(index)
                                    setIsView(true)
                                    setViewBool(true)
                                    setId(item.id)
                                  },
                                  icon: 'IconEye',
                                  iconColor: '',
                                  display: item.viewAccess,
                                },
                                {
                                  label: 'Edit',
                                  onClick: () => {
                                    handleToggleMenu(index)

                                    setId(item.id)
                                    setIsOpen(true)
                                    setIsEdit(true)
                                    setFormData({
                                      candidate: item?.candidate,
                                      employer: item?.employer,
                                      severity_level: item?.severity_level,
                                      overview: item?.overview,
                                      status: item?.status,
                                    } as FormData)
                                  },
                                  icon: 'IconEdit',
                                  iconColor: '',
                                  display: item.editAccess,
                                },
                                {
                                  label: 'Remove',
                                  onClick: () => {
                                    setIsOpenDelete(true)
                                    setId(item.id)
                                  },
                                  icon: 'IconTrash',
                                  iconColor: '#FF6666',
                                  textColor: 'text-textError',
                                  display: item.deleteAccess,
                                },
                              ]}
                              type={'table'}
                              setIsOpenMenu={setIsOpenMenu}
                              isOpenMenus={isOpenMenu}
                            >
                              <div
                                className="cursor-pointer"
                                onClick={() => handleToggleMenu(index)}
                              >
                                <Icon
                                  name={'IconDotsVertical'}
                                  width={16}
                                  height={16}
                                  strokeWidth={1.5}
                                  stroke={'#02698C'}
                                />
                              </div>
                            </Menu>
                          </td>
                        </tr>
                      </>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      )}
      {isView && (
        <div
          className=""
          style={{ height: 'calc(100vh - 100px)', overflow: 'auto' }}
        >
          <UISubHeaderComponent
            mainPage="Incidents"
            subPage={`Incident Report No. ${incidentById.data?.reportNo}`}
            copy=""
            isDelete={incidentById.data?.deleteAccess || false}
            isEdit={incidentById.data?.editAccess || false}
            isAccess={true}
            onEdit2={() => {
              handleOpenModal()
              setIsEdit(true)
              setFormData({
                candidate: incidentById?.data?.candidate,
                employer: incidentById?.data?.employer,
                severity_level: incidentById?.data?.severity_level,
                overview: incidentById?.data?.overview,
                status: incidentById?.data?.status,
              } as FormData)
            }}
            onDelete2={() => {
              setIsOpenDelete(true)
            }}
            onBack={() => {
              setIsView(false)
            }}
            isViewMode={true}
          />

          {/* content container */}

          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Report ID
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.reportNo}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Status
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div
                      className={`px-4 py-3 w-fit flex justify-center items-center bg-${statusBgColorWhistleblowing(incidentById?.data?.status)} h-[28px] rounded-[100px]`}
                    >
                      <p className="text-xs font-medium leading-5 text-text2">
                        {capitalizeFirstLetter(incidentById.data?.status || '')}
                      </p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Severity level
                  </td>
                  <td className="px-4 text-goldYellow font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <SeverityIcon
                      severity_level={
                        incidentById.data?.severity_level
                          ? incidentById.data?.severity_level
                          : ''
                      }
                    />
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Incident Concerning
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconUserCircle'}
                        strokeWidth={1}
                        stroke={'#02698C'}
                        width={16}
                        height={16}
                      />
                      <p> {incidentById.data?.candidate}</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Name of Employer
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconBuilding'}
                        strokeWidth={2}
                        stroke={'#02698C'}
                        width={26}
                        height={26}
                      />
                      <p>{incidentById?.data?.employer}</p>
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] min-h-[48px] py-2 border border-white">
                    Description
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] min-h-[48px] py-2 border border-white">
                    <div className="w-[400px] overflow-scroll flex-col">
                      {' '}
                      {incidentById.data?.overview}
                    </div>
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Created By
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconUserCircle'}
                        strokeWidth={1}
                        stroke={'#02698C'}
                        width={16}
                        height={16}
                      />
                      <p> {incidentById.data?.createdByName}</p>
                    </div>
                  </td>
                </tr>

                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Date Received
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.createdAt?.substring(0, 16)}
                  </td>
                </tr>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Date Reported
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.createdAt?.substring(0, 16)}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
            <table className="rounded-[16px] overflow-hidden border w-full border-white">
              <tbody>
                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated By
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    <div className=" px-[20px] rounded-[10px] gap-[5px] w-fit py-[10px] bg-gray2 flex justify-center items-center">
                      <Icon
                        name={'IconUserCircle'}
                        strokeWidth={1}
                        stroke={'#02698C'}
                        width={16}
                        height={16}
                      />
                      <p> {incidentById.data?.updatedByName}</p>
                    </div>
                  </td>
                </tr>

                <tr className="bg-gray1">
                  {/* Example row */}
                  <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                    Updated On
                  </td>
                  <td className="px-4 text-text1 font-semibold text-[14px] h-[48px] py-2 border border-white">
                    {incidentById.data?.updatedByName == null
                      ? ''
                      : incidentById.data?.updatedAt?.substring(0, 16)}
                  </td>
                </tr>

                {/* Add more rows as needed */}
              </tbody>
            </table>
          </div>
          {localStorage.getItem('userRole') == 'Safeguarding Lead' && (
            <>
              <p className={'text-text2 text-[14px] font-semibold'}>
                Further Information
              </p>

              <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
                <table className="rounded-[16px] overflow-hidden border w-full border-white">
                  <tbody>
                    <tr className="bg-gray1">
                      {/* Example row */}
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Support Requirement Rating
                      </td>
                      <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                        {incidentById.data?.supportRequirementRating}
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Immediate Action Taken
                      </td>
                      <td className="px-4 h-[48px] py-2 border flex items-center gap-3 border-white">
                        <p className="text-text3 font-normal text-sm">
                          {incidentById.data?.immediateActionTaken}
                        </p>
                        <Icon
                          name={'IconAlertTriangle'}
                          width={16}
                          height={16}
                          stroke="#67A5B9"
                        />
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Further Action Required
                      </td>
                      <td className="px-4 h-[48px] py-2 border flex items-center gap-3 border-white">
                        <p className="text-text3 font-normal text-sm">
                          {incidentById.data?.furtherActionRequired}
                        </p>
                        <Icon
                          name={'IconAlertTriangle'}
                          width={16}
                          height={16}
                          stroke="#67A5B9"
                        />
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Monitoring Required
                      </td>
                      <td className="px-4 h-[48px] py-2 border flex items-center gap-3 border-white">
                        <p className="text-text3 font-normal text-sm">
                          {incidentById.data?.monitoringRequired}
                        </p>
                        <Icon
                          name={'IconAlertTriangle'}
                          width={16}
                          height={16}
                          stroke="#67A5B9"
                        />
                      </td>
                    </tr>
                    <tr className="bg-gray1">
                      <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                        Conclusion of Outcome
                      </td>
                      <td className="px-4 h-[48px] py-2 border flex items-center gap-3 border-white">
                        <p className="text-text3 font-normal text-sm">
                          {incidentById.data?.conclusionOfOutcome}
                        </p>
                        <Icon
                          name={'IconAlertTriangle'}
                          width={16}
                          height={16}
                          stroke="#67A5B9"
                        />
                      </td>
                    </tr>

                    {/* Add more rows as needed */}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      )}

      {/* modal */}
      <Modal
        customStyle={{ width: '95%', height: '95%' }}
        isOpen={isOpen}
        onClose={handleCloseModal}
      >
        <div
          className={
            'max-h-[90vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              {isEdit ? 'Edit Incident Report' : 'Create Incident Report'}
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Please enter the details of the incident
            </p>
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <div className="w-[30%]">
              <UiSelect
                onChange={(e) => {
                  handleChange('status', e)
                }}
                value={formData.status}
                options={[
                  { value: 'open', label: 'open' },
                  { value: 'closed', label: 'closed' },
                ]}
                title={'Status'}
              />
            </div>
            <div className="w-[30%]  ">
              <UITextInput
                placeholder={''}
                label={'Incident Concerning*'}
                iconName={''}
                onChange={(e) => {
                  handleChange('candidate', e.target.value)
                }}
                value={formData.candidate}
              />
            </div>
            <div className="w-[30%]  ">
              <UITextInput
                placeholder={''}
                label={'Name of Employer*'}
                iconName={''}
                onChange={(e) => {
                  handleChange('employer', e.target.value)
                }}
                value={formData.employer}
              />
            </div>
          </div>
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]">
            <div className="w-[30%]  ">
              <UiSelect
                onChange={(e) => {
                  handleChange('severity_level', e)
                }}
                value={formData.severity_level}
                options={[
                  { value: 'minor', label: 'minor' },
                  { value: 'serious', label: 'serious' },
                  { value: 'well-being', label: 'well-being' },
                ]}
                title={'Severity Level*'}
              />
            </div>
          </div>

          <UITextArea
            label={'Overview of Concern*'}
            onChange={(e) => {
              handleChange('overview', e.target.value)
            }}
            rows={10}
            value={formData.overview}
            onBlur={() => {}}
            placeholder="Please enter your Description"
            iconName={'none'}
          />
          <div className="w-[100%] gap-[15px] justify-between flex mt-[10px]"></div>

          {localStorage.getItem('userRole') == 'Safeguarding Lead' && (
            <>
              <div
                onClick={() => {
                  setShowOtherPart(!showOtherPart)
                }}
                className={'w-full flex justify-between p-2 cursor-pointer'}
              >
                <p className="text-text2 text-sm font-semibold leading-6 ">
                  Further Information
                </p>
                <Icon name={'IconArrowDown'} />
              </div>
              {showOtherPart && (
                <>
                  <div className="w-full flex-col flex gap-4 mt-[10px]">
                    <UiSelect
                      onChange={(e) => {
                        handleChange('supportRequirementRating', e)
                      }}
                      value={formData.supportRequirementRating}
                      options={[
                        {
                          value: 'No further action required',
                          label: 'No further action required',
                        },
                        {
                          value:
                            'Safeguarding referral required to external agency',
                          label:
                            'Safeguarding referral required to external agency',
                        },
                        {
                          value: 'Prevent referral required',
                          label: 'Prevent referral required',
                        },
                        {
                          value: 'Urgent action required',
                          label: 'Urgent action required',
                        },
                        {
                          value: 'Monitoring required only',
                          label: 'Monitoring required only',
                        },
                      ]}
                      placeholder="Select"
                      title={'Support Requirement Rating*'}
                    />
                    <UITextArea
                      label={'Immediate Action Taken'}
                      onChange={(e) => {
                        handleChange('immediateActionTaken', e.target.value)
                      }}
                      value={formData.immediateActionTaken}
                      onBlur={() => {}}
                      placeholder="Not specified"
                      iconName={'none'}
                    />
                    <UITextArea
                      label={'Further Action Required'}
                      onChange={(e) => {
                        handleChange('furtherActionRequired', e.target.value)
                      }}
                      value={formData.furtherActionRequired}
                      onBlur={() => {}}
                      placeholder="Not specified"
                      iconName={'none'}
                    />
                    <UITextArea
                      label={'Monitoring Required'}
                      onChange={(e) => {
                        handleChange('monitoringRequired', e.target.value)
                      }}
                      value={formData.monitoringRequired}
                      onBlur={() => {}}
                      placeholder="Not specified"
                      iconName={'none'}
                    />
                    <UITextArea
                      label={'Conclusion of Outcome'}
                      onChange={(e) => {
                        handleChange('conclusionOfOutcome', e.target.value)
                      }}
                      value={formData.conclusionOfOutcome}
                      onBlur={() => {}}
                      placeholder="Not specified"
                      iconName={'none'}
                    />
                  </div>
                </>
              )}
            </>
          )}

          {/* other information */}
          <div className="w-[50%] absolute bottom-10">
            {isEdit ? (
              <button
                onClick={() => {
                  editIncident()
                  handleCloseModal()
                }}
                className="bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]"
              >
                Update
              </button>
            ) : (
              <button
                disabled={checkValidation(formData)}
                onClick={() => {
                  handleCloseModal()
                  createNewIncident()
                }}
                className=" disabled:bg-gray1 bg-bluishGreen text-white min-h-[48px] w-[100%] font-medium rounded-[72px] text-[14px]"
              >
                Create
              </button>
            )}
          </div>
        </div>
      </Modal>

      <Modal
        customStyle={{
          borderRadius: 16,
          padding: '16px 8px',
          width: '480px',
        }}
        isOpen={isExportOpen}
        onClose={handleExportCloseModal}
      >
        {isConfrim ? (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center flex flex-col gap-4 py-4 px-8'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-lg font-bold leading-6'}>
                Export Data
              </h1>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 text-center'
                }
              >
                The {fileType} export file will be generated for download.
                Disable any popup blockers in your browser to ensure proper
                download. <span className="mt-3">Ok to proceed?</span>
              </p>
              <p
                className={
                  'text-sm text-text1 font-normal leading-6 mt-4 text-center'
                }
              >
                Ok to proceed?
              </p>
            </div>
            <div className="w-full flex flex-col gap-2 mt-2">
              {(fileType == 'Excel95' || fileType == 'Excel2007') && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    exportToExcel(incidents?.data?.data, 'data', fileType)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'HTML' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    const html = UIExportHtmlTable({
                      columns: columns,
                      data: incidents?.data?.data || [],
                    })
                    if (html) {
                      handleDownloadHtml(html)
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }
                  }}
                />
              )}
              {fileType == 'Text' && (
                <UIButton
                  label="Confirm"
                  onClick={() => {
                    handleDownloadTxt(incidents?.data?.data)
                    handleExportCloseModal()
                    setIsConfrim(!isConfrim)
                  }}
                />
              )}
              {fileType == 'CSV' && (
                <CSVLink
                  target="_blank"
                  filename={'data.csv'}
                  headers={fileHeader}
                  data={
                    incidents?.data?.data?.map((item) => ({
                      Report_No: item.reportNo,
                      Status: item.status,
                      Severity_Level: item.severity_level,
                      Name_of_Candidate: item.candidate,
                      Name_of_Employer: item.employer,
                      Date_Reported: item?.createdAt,
                      Updated_At: item.updatedAt,
                      Created_By: item.createdBy,
                      Updated_By: item.updatedBy,
                    })) || []
                  }
                >
                  <UIButton
                    label="Confirm"
                    onClick={() => {
                      handleExportCloseModal()
                      setIsConfrim(!isConfrim)
                    }}
                  />
                </CSVLink>
              )}

              <UIButton
                secondary
                label="Cancel"
                onClick={() => setIsConfrim(!isConfrim)}
              />
            </div>
          </div>
        ) : (
          <div
            className={
              'max-h-[100vh] overflow-scroll custom-scrollbar items-center p-4 flex flex-col gap-4'
            }
          >
            <div
              onClick={handleExportCloseModal}
              className="flex w-[100%] justify-end cursor-pointer"
            >
              <Icon
                name={'IconCross'}
                stroke="#02698C"
                height={16}
                width={16}
              />
            </div>
            <div className="flex items-center w-[100%] justify-center">
              <Icon
                name={'IconExportData'}
                height={52}
                width={52}
                strokeWidth={1}
                stroke="#02698C"
              />
            </div>
            <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
              <h1 className={'text-text2 text-[18px] font-bold'}>
                Export Data
              </h1>
              <p className={'text-[14px] text-text1 font-normal'}>
                Please choose the data you want to export and file type.
              </p>
            </div>
            <div className="w-[420px] flex-col flex gap-4 my-[15px]">
              <UIMultiSelect
                options={[
                  {
                    value: 'Report_No',
                    label: 'Report No',
                  },
                  {
                    value: 'Status',
                    label: 'Status',
                  },
                  {
                    value: 'Severity_Level',
                    label: 'Severity Level',
                  },
                  {
                    value: 'Name_of_Candidate',
                    label: 'Incident Concerning',
                  },
                  {
                    value: 'Name_of_Employer',
                    label: 'Name of Employer',
                  },
                  {
                    value: 'Date_Reported',
                    label: 'Date Reported',
                  },
                  {
                    value: 'Updated_At',
                    label: 'Updated At',
                  },
                  {
                    value: 'Created_By',
                    label: 'Created By',
                  },
                  {
                    value: 'Updated_By',
                    label: 'Updated By',
                  },
                ]}
                title={'Select Export Columns'}
              />
              <UiSelect
                title={'Choose Filetype'}
                placeholder="Please specify"
                labelClass={'text-xs'}
                onChange={(value) => setFileType(value)}
                selectedOptionClass={
                  'text-sm font-semibold leading-6 text-text4'
                }
                options={[
                  {
                    value: 'HTML',
                    label: 'HTML',
                    iconName: 'IconGlobe',
                  },
                  {
                    value: 'CSV',
                    label: 'CSV',
                    iconName: 'IconCodeSquare',
                  },
                  {
                    value: 'Text',
                    label: 'Text',
                    iconName: 'IconFile',
                  },
                  {
                    value: 'Excel95',
                    label: 'Excel 95 +',
                    iconName: 'IconBarChartCircle',
                  },
                  {
                    value: 'Excel2007',
                    label: 'Excel 2007 +',
                    iconName: 'IconBarChartSquare',
                  },
                ]}
              />
            </div>
            <div className="w-full">
              <button
                onClick={() => {
                  if (
                    fileType == 'CSV' ||
                    fileType == 'Text' ||
                    fileType == 'HTML' ||
                    fileType == 'Excel95' ||
                    fileType == 'Excel2007'
                  )
                    setIsConfrim(!isConfrim)
                }}
                className=" bg-bluishGreen text-white min-h-[48px] w-[98%] font-medium rounded-[72px] text-[14px]  "
              >
                Export Data
              </button>
            </div>
          </div>
        )}
      </Modal>
      <Modal
        customStyle={{ width: '480px', borderRadius: 16 }}
        isOpen={isOpenDelete}
        onClose={handleCloseDeleteModal}
      >
        <div
          className={
            'max-h-[80vh] overflow-scroll custom-scrollbar items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={handleCloseDeleteModal}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconAlertTriangle'}
              stroke={'#FF6666'}
              strokeWidth={1}
              height={52}
              width={52}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-[18px] font-bold'}>
              Delete Incident Report
            </h1>
            <p className={'text-[14px] text-text1 font-normal'}>
              Are you sure you want to delete this incident report?
            </p>
          </div>

          <button
            onClick={() => {
              removePolicy()
              setIsView(false)
            }}
            className=" text-textError border-textError border-[1px] min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Yes, I am Sure
          </button>
          <button
            onClick={handleCloseDeleteModal}
            className=" text-text3 border-textError bg-gray2 min-h-[48px] w-[95%] font-medium rounded-[72px] text-[14px]  "
          >
            Cancel
          </button>
        </div>
      </Modal>
    </div>
  )
}

export default Incidents
